export default "__VITE_ASSET__eNb0GiyH__"